<template>
  <!-- 新增的对话框 -->
  <el-dialog
    center
    width="600px"
    title="修改密码"
    :visible.sync="dialogFormVisible"
    @closed="closed"
  >
    <el-form :model="editForm" :rules="editRules" ref="editForm">
      <!--  oldPwd: '',
        newPwd: '',
        comfirmPwd: '', -->
      <el-form-item label="旧密码" :label-width="formLabelWidth" prop="oldPwd">
        <el-input
          type="password"
          v-model="editForm.oldPwd"
          placeholder="请输入旧密码"
        />
      </el-form-item>
      <el-form-item label="新密码" :label-width="formLabelWidth" prop="newPwd">
        <el-input
          type="password"
          v-model="editForm.newPwd"
          placeholder="请输入新密码"
        />
      </el-form-item>
      <el-form-item
        label="确认新密码"
        :label-width="formLabelWidth"
        prop="comfirmPwd"
      >
        <el-input
          type="password"
          v-model="editForm.comfirmPwd"
          placeholder="请输入确认新密码"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitEdit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { changePasswordApi } from '@/api/user.js';
// import { getToken } from '@/utils/token.js'
export default {
  name: 'ChangePassword',
  data() {
    return {
      formLabelWidth: '120px', // 对话框中 文本的尺寸
      dialogFormVisible: false, // 是否显示对话框
      userOptions: [],
      loading: false,
      // 编辑表单
      editForm: {
        oldPwd: '',
        newPwd: '',
        comfirmPwd: '',
      },
      // 表单的验证规则
      editRules: {
        oldPwd: [
          { required: true, message: '请请输入旧密码', trigger: 'blur' },
        ],
        newPwd: [
          { required: true, message: '请请输入新密码', trigger: 'blur' },
        ],
        comfirmPwd: [
          { required: true, message: '请请输入确认密码', trigger: 'blur' },
        ],
      },
    };
  },

  mounted() {},
  methods: {
    // 提交按钮
    submitEdit() {
      try {
        this.$refs.editForm.validate(async (valid) => {
          if (!valid) return;
          if (this.editForm.newPwd !== this.editForm.comfirmPwd) {
            return this.$message.error('新密码和确认密码不一致，请重新输入！');
          }
          changePasswordApi(this.editForm).then((res) => {
            if (res.code == 200) {
              this.$message.success('修改成功！');
              this.dialogFormVisible = false;
              this.closed();
            } else {
              this.$message.error(this.res.message);
            }
          });
        });
      } catch (e) {
        window.console.log(e);
      }
    },
    // 关闭时的回调
    closed() {
      this.$refs.editForm.resetFields();
    },
  },
  created() {},
};
</script>

<style lang="less" scoped></style>
